// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"8fdd8d9b","110":"e5ca1e07","122":"63bf8143","248":"bb5cf7b8","292":"b10c0854","427":"66386174","583":"cb62f992","619":"5f3d5237","729":"67cfb618","746":"4543438f","943":"d2892c90","956":"83b7dbff"}[chunkId] + ".chunk.js";
};